import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useAuth } from "./AuthContext";
import Api from "../Services/Api";

export default function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const lastPathRef = useRef("");
  const lastSentRef = useRef(0);

  useEffect(() => {
    if (loading || !user) return;

    const path = location.pathname;
    const now = Date.now();

    if (lastPathRef.current === path && now - lastSentRef.current < 1000) {
      return;
    }

    lastPathRef.current = path;
    lastSentRef.current = now;

    Api.post("/logs/page-view", {
      path,
      title: document.title || null,
      origin: "FRONT",
    }).catch(() => {});
  }, [location.pathname, loading, user]);

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  return <Outlet />;
}
